// src/pages/settings/components/ChannelPartnerDeleteModal.js

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert
} from '@mui/material';

const ChannelPartnerDeleteModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  deletingPartner, 
  loading = false 
}) => {
  if (!deletingPartner) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete the channel partner "{deletingPartner.name}"?
          This action cannot be undone.
        </Typography>
        {deletingPartner.leads_count > 0 && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            This channel partner has {deletingPartner.leads_count} associated leads. 
            Deleting will remove the association but keep the leads.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChannelPartnerDeleteModal;
